import { ACCOUNT_PROPERTY_FORM_RESET, CREATE_ACCOUNT_PROPERTY_FORM, CREATE_ACCOUNT_PROPERTYS_FAILURE, CREATE_ACCOUNT_PROPERTYS_REQUEST, CREATE_ACCOUNT_PROPERTYS_SUCCESS, FETCH_ACCOUNT_PROPERTYS_FAILURE, FETCH_ACCOUNT_PROPERTYS_REQUEST, FETCH_ACCOUNT_PROPERTYS_SUCCESS, FETCH_SINGLE_ACCOUNT_PROPERTYS_FAILURE, FETCH_SINGLE_ACCOUNT_PROPERTYS_REQUEST, FETCH_SINGLE_ACCOUNT_PROPERTYS_SUCCESS } from './AccountProperty.actionType';


export const ACCOUNT_PROPERTY = 'accountProperty';

let initialState = {
    loading: false,
    accountPropertyList: [],
    detailsId: '',
    uploadId: '',
    accountPropertyForm: {},
    DeleteDetailFormData: '',

    // cashForm: {},
    selectedCashRequisitionDetails: {},
    errorMessage: '',
    iperrorMessage: '',
    fldknittingProgramId: ''
};

export let AccountPropertyReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    console.log('updatePayload', updatePayload)

    switch (type) {
        case FETCH_ACCOUNT_PROPERTYS_REQUEST:
        case FETCH_SINGLE_ACCOUNT_PROPERTYS_REQUEST:
        case CREATE_ACCOUNT_PROPERTYS_REQUEST:
        
            return {
                ...state,
                loading: true
            };
        case FETCH_ACCOUNT_PROPERTYS_SUCCESS:
            return {
                ...state,
                loading: false,
                accountPropertyList: updatePayload,
                // detailsId: updatePayload
            };
        case FETCH_SINGLE_ACCOUNT_PROPERTYS_SUCCESS:
            return {
                ...state,
                loading: false,
                accountPropertyForm: updatePayload
            };
        
        case CREATE_ACCOUNT_PROPERTY_FORM:
            return {
                ...state,
                loading: false,
                accountPropertyForm: {
                    ...state.accountPropertyForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_ACCOUNT_PROPERTYS_SUCCESS:
            return {
                ...state,
                loading: false,
                accountPropertyForm: updatePayload,
            };
        
        case FETCH_ACCOUNT_PROPERTYS_FAILURE:
        case FETCH_SINGLE_ACCOUNT_PROPERTYS_FAILURE:
        case CREATE_ACCOUNT_PROPERTYS_FAILURE:

            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        case ACCOUNT_PROPERTY_FORM_RESET:
            return {
                ...state,
                accountPropertyForm: {},
                // selectedCashRequisitionDetails: {}
            };


        default:
            return state;
    }
};
